module.exports = __webpack_public_path__ + "static/media/flag-hong-kong.9990342e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/shared/LanguageFlag/LanguageFlagIcons/flag-hong-kong.svg
// module id = 1129
// module chunks = 1